import { render } from "./Complaint.vue?vue&type=template&id=62cd380c&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"

import "./Complaint.vue?vue&type=style&index=0&id=62cd380c&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd380c"]])

export default __exports__